export const MiscActionTypes = {
    SET_APP_INIT: "SET_APP_INIT",
    SET_SINGLE_VIDEO: "SET_SINGLE_VIDEO",
    SET_CAMPAIGN_ANSWERED: "SET_CAMPAIGN_ANSWERED",
    SET_TARGETS_APPS: "SET_TARGETS_APPS",
    SET_CURRENCIES: "SET_CURRENCIES",
    SET_CURRENT_IP: "SET_CURRENT_IP",
    SET_CURRENT_CURRENCY: "SET_CURRENT_CURRENCY",
}
